module.exports = __webpack_public_path__ + "img/gameBg.cbdcc27b.png";